import { useMemo } from 'react';
import { shallowEqual } from 'react-redux';
import { useAppSelector } from 'universal-scripts';

export const useSourcesStore = () => {
	const sourcesData = useAppSelector((s) => s?.sources, shallowEqual);

	return useMemo(() => {
		const sources = sourcesData?.sources || [];
		const internetSources = sourcesData?.internetSources || [];
		const messageId = sourcesData?.messageId;

		const usedSources = sources?.filter((s) => s.position);
		const unUsedSources = sources?.filter((s) => !s.position);
		const hasSources = sources?.length > 0;
		const hasInternetSources = internetSources?.length > 0;
		const hasUsedSources = usedSources?.length > 0;
		const hasUnUsedSources = unUsedSources?.length > 0;

		return {
			sources,
			internetSources,
			usedSources,
			unUsedSources,
			hasSources,
			hasInternetSources,
			hasUsedSources,
			hasUnUsedSources,
			messageId
		};
	}, [sourcesData]);
};
